import { withHandlers } from "reassemble";
export var withDOMNodeCallback = withHandlers(function () {
  var ref;
  return {
    onDOMNodeRef: function onDOMNodeRef() {
      return function (e) {
        ref = e;
      };
    },
    getDOMNode: function getDOMNode() {
      return function () {
        return ref;
      };
    }
  };
});